import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        h1: {
            marginTop: 30,
            fontSize: 30
        },
        h2: {
            fontSize: 24
        },
        h3: {
            fontSize: 20
        },
        body1: {
            fontSize: 16
        }
    },
    palette: {
        // mode: 'dark',
        primary: {
            main: '#1a237e'
        },
        secondary: {
            main: '#f50057'
        }
    }
});

export default theme;
